import * as albumActions from '../../pages/album/albumActions'
import * as trackActions from '../../pages/track/trackActions'
import * as artistActions from '../../pages/artist/artistActions'
import * as playlistActions from '../../pages/playlist/playlistActions'
import * as focusActions from '../../pages/focus/focusActions'

const shareInit = {
	type: null,
	subject: {},
	body: {},
	twitter: {},
	facebook: {},
	url: ''
}
export default (state = shareInit, action) => {
	switch (action.type) {
		case albumActions.GET_ALBUM_SUCCESS:
			if (action.album) {
				return {
					type: 'album',
					subject: {
						title: action.album.title,
						artist: action.album.artist ? action.album.artist.name : ''
					},
					body: {
						id: action.album.id,
						title: action.album.title,
						artist: action.album.artist ? action.album.artist.name : ''
					},
					twitter: {
						title: action.album.title,
						artist: action.album.artist ? action.album.artist.name : ''
					},
					url: `https://open.qobuz.com/album/${action.album.id}`
				}
			}
			return shareInit
		case trackActions.GET_TRACK_SUCCESS:
			if (action.track) {
				return {
					type: 'track',
					subject: {
						title: action.track.title,
						artist: action.track.album && action.track.album.artist ? action.track.album.artist.name : ''
					},
					body: {
						id: action.track.id,
						title: action.track.title,
						artist: action.track.album && action.track.album.artist ? action.track.album.artist.name : ''
					},
					twitter: {
						title: action.track.title,
						artist: action.track.album && action.track.album.artist ? action.track.album.artist.name : ''
					},
					url: `https://open.qobuz.com/track/${action.track.id}`
				}
			}
			return shareInit
		case artistActions.GET_ARTIST_SUCCESS:
			if (action.infos) {
				return {
					type: 'artist',
					subject: {
						artist: action.infos.name
					},
					body: {
						id: action.infos.id,
						artist: action.infos.name
					},
					twitter: {
						artist: action.infos.name
					},
					url: `https://open.qobuz.com/artist/${action.infos.id}`
				}
			}
			return shareInit
		case playlistActions.GET_PLAYLIST_SUCCESS:
			if (action.playlist) {
				return {
					type: 'playlist',
					subject: {
						playlist: action.playlist.name,
						owner: action.playlist.owner ? action.playlist.owner.name : ''
					},
					body: {
						id: action.playlist.id,
						playlist: action.playlist.name,
						owner: action.playlist.owner ? action.playlist.owner.name : ''
					},
					twitter: {
						playlist: action.playlist.name,
						owner: action.playlist.owner ? action.playlist.owner.name : ''
					},
					url: `https://open.qobuz.com/playlist/${action.playlist.id}`
				}
			}
			return shareInit
		case focusActions.GET_FOCUS_SUCCESS:
			if (action.id) {
				return {
					type: 'focus',
					subject: {
						title: action.title ? action.title.title : '',
					},
					body: {},
					twitter: {},
					url: `https://open.qobuz.com/focus/${action.id}`
				}
			}
			return shareInit
		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/components/header/shareReducer.js